import React from 'react';
import {AssigneeModel} from '@/typings/models/Assignee';
import AgentInfoEdit from '@/components/AgentInfoEdit';
import {Space, Typography} from 'antd';
import {InfoCircleOutlined} from '@ant-design/icons';
import {F} from '@/utils/intl';
import {AvailabilityTimezoneHint} from '@/components/Availability/AvailabilityTimezone';
import {getAgentBranchTimezones} from '@/utils/user';

interface AgentAvailabilityTabProps {
  agent: AssigneeModel;
  onGoToService: () => void;
  onDirty?: () => void;
}

const AgentAvailabilityTab: React.FC<AgentAvailabilityTabProps> = ({
  agent,
  onGoToService,
  onDirty
}) => (
  <div>
    <div style={{ marginBottom: 12 }}>
      <AvailabilityTimezoneHint timezones={getAgentBranchTimezones(agent)} />
    </div>
    <AgentInfoEdit agent={agent} type={'calendar'} onDirty={onDirty} />
    {false && <Typography.Text type={'secondary'}>
      <small>
        <Space size={4}>
          <InfoCircleOutlined />
          <F
            id={'pages.users.custom_availability_hint'}
            defaultMessage={
              'To manage custom availability for each provided service by the user, go to'
            }
          />
          <a onClick={onGoToService}>
            <F id={'entity.service.plural'} />
          </a>
        </Space>
      </small>
    </Typography.Text>}
  </div>
);

export default AgentAvailabilityTab;
